import {
  endpoints,
  SmartInviteClaimInvites,
  SmartInviteConversation,
  SmartInviteExperienceConversations,
  SmartInviteHostConversations,
  SmartInviteUnreadConversations,
} from '@seaters/constants';
import { api } from '../axios-instance';

const base = endpoints.smartInvites;
const hostInvite = (fanGroupId: string, inviteId: string) =>
  `${base}/${endpoints.host}/${endpoints.fanGroups}/${fanGroupId}/invites/${inviteId}/conversation`;
const hostInviteFgo = (fanGroupId: string, inviteId: string) =>
  `${base}/${endpoints.host}/${endpoints.fanGroups}/${fanGroupId}/invites/${inviteId}/fgo-conversation`;
const myInvite = (inviteId: string) =>
  `${base}/${endpoints.guest}/menu/invites/${inviteId}/conversation`;

export const fetchSmartInviteConversation = (
  fanGroupId: string,
  inviteId: string
): Promise<SmartInviteConversation> =>
  api.get(hostInvite(fanGroupId, inviteId));

export const postSmartInviteHostMessage = (
  fanGroupId: string,
  inviteId: string,
  body: string
): Promise<SmartInviteConversation> =>
  api.post(`${hostInvite(fanGroupId, inviteId)}/messages`, { body });

/** `seenUntil`: createdAt of the newest message on screen; a later one stays unread. */
export const markSmartInviteConversationRead = (
  fanGroupId: string,
  inviteId: string,
  seenUntil: string
): Promise<void> =>
  api.post(`${hostInvite(fanGroupId, inviteId)}/read`, { seenUntil });

export const fetchSmartInviteHostConversations = (
  fanGroupId: string
): Promise<SmartInviteHostConversations> =>
  api.get(
    `${base}/${endpoints.host}/${endpoints.fanGroups}/${fanGroupId}/conversations`
  );

export const fetchSmartInviteUnreadConversations = (
  fanGroupId: string
): Promise<SmartInviteUnreadConversations> =>
  api.get(
    `${base}/${endpoints.host}/${endpoints.fanGroups}/${fanGroupId}/conversations/unread`
  );

export const fetchMySmartInviteConversation = (
  inviteId: string
): Promise<SmartInviteConversation> => api.get(myInvite(inviteId));

export const postMySmartInviteMessage = (
  inviteId: string,
  body: string
): Promise<SmartInviteConversation> =>
  api.post(`${myInvite(inviteId)}/messages`, { body });

export const markMySmartInviteConversationRead = (
  inviteId: string,
  seenUntil: string
): Promise<void> => api.post(`${myInvite(inviteId)}/read`, { seenUntil });

export const fetchSmartInviteExperienceConversations = (
  fanGroupId: string,
  waitingListId: string
): Promise<SmartInviteExperienceConversations> =>
  api.get(
    `${base}/conversations/${endpoints.fanGroups}/${fanGroupId}/waiting-lists/${waitingListId}`
  );

export const fetchSmartInviteFgoConversation = (
  fanGroupId: string,
  inviteId: string
): Promise<SmartInviteConversation> =>
  api.get(hostInviteFgo(fanGroupId, inviteId));

export const postSmartInviteFgoMessage = (
  fanGroupId: string,
  inviteId: string,
  body: string
): Promise<SmartInviteConversation> =>
  api.post(`${hostInviteFgo(fanGroupId, inviteId)}/messages`, { body });

export const markSmartInviteFgoConversationRead = (
  fanGroupId: string,
  inviteId: string,
  seenUntil: string
): Promise<void> =>
  api.post(`${hostInviteFgo(fanGroupId, inviteId)}/read`, { seenUntil });

export const fetchSmartInviteUnreadFgoConversations = (
  fanGroupId: string,
  approvalsOnly = false
): Promise<SmartInviteUnreadConversations> =>
  api.get(
    `${base}/${endpoints.host}/${endpoints.fanGroups}/${fanGroupId}/fgo-conversations/unread`,
    approvalsOnly ? { params: { approvalsOnly: true } } : undefined
  );

export const fetchSmartInviteClaimInvites = (
  fanGroupId: string,
  selectionIds: string[]
): Promise<SmartInviteClaimInvites> =>
  api.get(`${base}/conversations/${endpoints.fanGroups}/${fanGroupId}/claims`, {
    params: { selectionIds: selectionIds.join(',') },
  });
